import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiMembersBusinessSectionRelationEmployeesIndexRequestType,
  ApiMembersBusinessSectionRelationEmployeesIndexResponseType,
} from "~/domains";

type RequestDataType = {
  params?: ApiMembersBusinessSectionRelationEmployeesIndexRequestType;
};

const request = async ({
  params,
}: RequestDataType): Promise<ApiMembersBusinessSectionRelationEmployeesIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiMembersBusinessSectionRelationEmployeesIndexResponseType>(
      "/api/members/business_section_relation_employees",
      { ...params },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiMembersBusinessSectionRelationEmployeesIndexRequestType;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisMembersBusinessSectionRelationEmployeesIndex = ({
  params,
  config = {},
}: PropsType = {}): UseQueryResult<ApiMembersBusinessSectionRelationEmployeesIndexResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisMembersBusinessSectionRelationEmployeesIndex", params],
    queryFn: () => request({ params }),
  });
};
